/** @format */

import React, { useState } from 'react'
import styled from 'styled-components'
import { _$, Dialog, Input, Message, Tip } from '@king-design/react'
import { SceneRecordItemProp } from '../container'
import { deleteScene } from 'src/api/ApiEventOpsScene'

interface DeleteRuleDialogProps {
  className?: string
  visible: boolean
  record: SceneRecordItemProp
  onClose: (update?: boolean) => void
}

const DeleteRuleDialog: React.FC<DeleteRuleDialogProps> = ({
  className,
  visible,
  record,
  onClose
}) => {
  const [confirmName, setConfirmName] = useState<string>('')

  const onDeleteTrigger = async () => {
    const result = await deleteScene({
      Sign: record.Sign
    })
    if (result) {
      Message.success(_$("删除成功"))
      onClose(true)
      setConfirmName('')
    }
  }

  return (
    <Dialog
      value={visible}
      width={500}
      title={_$('确认删除')}
      onChangeValue={show => {
        if (!show) {
          onClose()
          setConfirmName('')
        }
      }}
      disabledOk={confirmName !== record?.Name}
      ok={onDeleteTrigger}
    >
      {record ? (
        <div className={className}>
          <Tip type="warning" showIcon>
            {_$("将删除场景数据，且不可恢复！删除前确保没有被触发器引用，且没有正在审批中的记录")}
          </Tip>
          <div className="ksc-space">
            {_$("请输入场景名称")}
            <b>{record.Name}</b>
            {_$("进行删除确认")}
            <Input
              placeholder={record.Name}
              value={confirmName}
              onChangeValue={value => {
                setConfirmName(value)
              }}
            />
          </div>
        </div>
      ) : null}
    </Dialog>
  )
}

export default styled(DeleteRuleDialog)`
  .ksc-space {
    text-align: center;
    margin-top: 16px;
    padding-left: 38px;
    .k-input {
      margin-top: 16px;
    }
  }
`
